import React from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

const FOOTER_COLUMNS = [
  {
    title: 'Information',
    links: [
      { label: 'Home', href: 'https://trytrivia.co/' },
      { label: 'Pricing', href: 'https://trytrivia.co/pricing/' },
      { label: 'Success stories', href: 'https://trytrivia.co/success-stories/' }
    ]
  },
  {
    title: 'Resources',
    links: [
      { label: 'Blog', to: '/blog' },
      { label: 'Knowledge base', href: 'https://trytrivia.co/knowledge-base/' },
      { label: 'Integrations', href: 'https://trytrivia.co/integrations/' }
    ]
  },
  {
    title: 'Features',
    links: [
      { label: 'Games', href: 'https://trytrivia.co/games/' },
      { label: 'Virtual Water Cooler', href: 'https://trytrivia.co/virtual-water-cooler/' },
      { label: 'Employee milestones', href: 'https://trytrivia.co/employee-milestones/' },
      { label: 'Know Your Team', href: 'https://trytrivia.co/know-your-team/' }
    ]
  },
  {
    title: 'Platforms',
    links: [
      { label: 'Trivia for Slack', href: 'https://trytrivia.co/slack/' },
      { label: 'Trivia for Microsoft Teams', href: 'https://trytrivia.co/microsoft-teams/' },
      { label: 'Security', href: 'https://trytrivia.co/security/' }
    ]
  }
];

const BlogFooter = () => (
  <footer className={styles.footer}>
    <div className={styles.footerInner}>
      <div className={styles.footerTop}>
        <div className={styles.brandColumn}>
          <Link className={styles.logo} to='/blog'>
            <span className={styles.logoMark}>?</span>
            <span>Trivia</span>
          </Link>
          <p>
            Virtual team building through fun and social games, right where your team works.
          </p>
          <div className={styles.ctaLinks}>
            <a href='https://trytrivia.co/slack/'>Add to Slack</a>
            <a href='https://trytrivia.co/microsoft-teams/'>Add to Teams</a>
          </div>
        </div>

        <div className={styles.footerColumns}>
          {FOOTER_COLUMNS.map((column) => (
            <div className={styles.footerColumn} key={column.title}>
              <h2>{column.title}</h2>
              {column.links.map((link) =>
                link.to ? (
                  <Link key={link.label} to={link.to}>
                    {link.label}
                  </Link>
                ) : (
                  <a href={link.href} key={link.label}>
                    {link.label}
                  </a>
                )
              )}
            </div>
          ))}
        </div>
      </div>

      <div className={styles.footerBottom}>
        <span>© {new Date().getFullYear()} Trivia. All rights reserved.</span>
        <div>
          <a href='https://trytrivia.co/privacy-policy/'>Privacy policy</a>
          <a href='https://trytrivia.co/cookie-policy/'>Cookies policy</a>
          <a href='https://trytrivia.co/tnc/'>Terms &amp; conditions</a>
        </div>
      </div>
    </div>
  </footer>
);

export default BlogFooter;
